// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Carousel Container */
.carousel-container {
    position: relative;
    max-width: 100%;
    margin: auto;
    overflow: hidden;
  }
  
  /* Carousel itself */
  .carousel {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }
  
  /* Carousel Image */
  .carousel-image {
    width: 100%;
    height: auto;
    max-height: 500px;
    object-fit: cover;
    transition: transform 0.5s ease-in-out;
  }
  
  /* Buttons */
  .prev-btn, .next-btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    border: none;
    padding: 10px;
    cursor: pointer;
    font-size: 24px;
    z-index: 1;
  }
  
  .prev-btn {
    left: 10px;
  }
  
  .next-btn {
    right: 10px;
  }
  
  /* Dots for indicator */
  .carousel-indicators {
    text-align: center;
    position: absolute;
    bottom: 10px;
    width: 100%;
  }
  
  .dot {
    height: 10px;
    width: 10px;
    margin: 0 5px;
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 50%;
    display: inline-block;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  
  .dot.active {
    background-color: white;
  }
  
  /* Responsive Design */
  @media (min-width: 768px) {
    .carousel-image {
      max-height: 600px;
    }
  }
  
  @media (min-width: 1024px) {
    .carousel-image {
      max-height: 700px;
    }
  
    .prev-btn, .next-btn {
      padding: 15px;
      font-size: 30px;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/Carousel.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;IACI,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,gBAAgB;EAClB;;EAEA,oBAAoB;EACpB;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA,mBAAmB;EACnB;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,sCAAsC;EACxC;;EAEA,YAAY;EACZ;IACE,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,oCAAoC;IACpC,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,eAAe;IACf,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA,uBAAuB;EACvB;IACE,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,aAAa;IACb,oCAAoC;IACpC,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,uBAAuB;EACzB;;EAEA,sBAAsB;EACtB;IACE;MACE,iBAAiB;IACnB;EACF;;EAEA;IACE;MACE,iBAAiB;IACnB;;IAEA;MACE,aAAa;MACb,eAAe;IACjB;EACF","sourcesContent":["/* Carousel Container */\n.carousel-container {\n    position: relative;\n    max-width: 100%;\n    margin: auto;\n    overflow: hidden;\n  }\n  \n  /* Carousel itself */\n  .carousel {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n  }\n  \n  /* Carousel Image */\n  .carousel-image {\n    width: 100%;\n    height: auto;\n    max-height: 500px;\n    object-fit: cover;\n    transition: transform 0.5s ease-in-out;\n  }\n  \n  /* Buttons */\n  .prev-btn, .next-btn {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    background-color: rgba(0, 0, 0, 0.5);\n    color: white;\n    border: none;\n    padding: 10px;\n    cursor: pointer;\n    font-size: 24px;\n    z-index: 1;\n  }\n  \n  .prev-btn {\n    left: 10px;\n  }\n  \n  .next-btn {\n    right: 10px;\n  }\n  \n  /* Dots for indicator */\n  .carousel-indicators {\n    text-align: center;\n    position: absolute;\n    bottom: 10px;\n    width: 100%;\n  }\n  \n  .dot {\n    height: 10px;\n    width: 10px;\n    margin: 0 5px;\n    background-color: rgba(0, 0, 0, 0.5);\n    border-radius: 50%;\n    display: inline-block;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n  }\n  \n  .dot.active {\n    background-color: white;\n  }\n  \n  /* Responsive Design */\n  @media (min-width: 768px) {\n    .carousel-image {\n      max-height: 600px;\n    }\n  }\n  \n  @media (min-width: 1024px) {\n    .carousel-image {\n      max-height: 700px;\n    }\n  \n    .prev-btn, .next-btn {\n      padding: 15px;\n      font-size: 30px;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
